/**
 * Deaktiviert Menüpunkte mit dem Titel "-" (z. B. reine Trennlinien/Platzhalter im Header-Menü).
 * Betrifft sowohl Desktop-Mega-Menü als auch mobiles Drawer-Menü, da beide
 * dieselben Klassen (.menu-list__link, .menu-list__item) verwenden.
 * Deaktivierung erfolgt per JS statt CSS-Selektor, da der Menüpunkt anhand
 * seines sichtbaren Textinhalts erkannt wird (CSS kann das nicht zuverlässig).
 */
document.querySelectorAll('.menu-list__link, .menu-list__item').forEach((link) => {
  if (link.textContent.trim() === '-') {
    link.style.pointerEvents = 'none';
    link.style.cursor = 'default';
    link.setAttribute('aria-disabled', 'true');
    link.addEventListener('click', (e) => e.preventDefault());
  }
});